// @flow
// import update from 'immutability-helper';
import { Observable, of } from 'rxjs';
import { catchError, debounceTime, map, takeUntil, switchMap } from 'rxjs/operators';
import type { RootState } from '../../index';
import { searchProductApi } from './api';
import { ofType, StateObservable } from 'redux-observable';
import { actions as NewOrderActions } from '../duck';

import type { HTTPError } from '../../../error';
import type { OnlineStore } from '../../../entities';

type SearchStepAction = {
  +type: string;
  +name?: string;
  +products?: any;
  +queryFilter?: { [key: string]: string };
  +error?: HTTPError;
  +isLast?: boolean;
  +resetPagination?: boolean;
};

export type SearchStepState = {
  isFetchingProducts?: boolean;
  fetchProductsError?: HTTPError;
  products?: SearchProduct[];
  page?: number;
  pageCanAsk?: boolean;
};

export type SearchProduct = {
  onlineStore: OnlineStore;
  image: string;
  name: string;
  price: string;
  url: string;
};

// Actions
const SEARCH_STEP_SEARCH_REQUEST = 'SEARCH_STEP_SEARCH_REQUEST';
const SEARCH_STEP_SEARCH_SUCCESS = 'SEARCH_STEP_SEARCH_SUCCESS';
const SEARCH_STEP_SEARCH_ERROR = 'SEARCH_STEP_SEARCH_ERROR';

// Action creators
export function searchProduct(name: string, queryFilter?: { [key: string]: string } = {}, resetPagination?: boolean): SearchStepAction {
  return {
    type: SEARCH_STEP_SEARCH_REQUEST,
    name,
    queryFilter,
    resetPagination,
  };
}

export function searchProductSuccess(products: SearchProduct[], isLast: boolean): SearchStepAction {
  return {
    type: SEARCH_STEP_SEARCH_SUCCESS,
    products,
    isLast,
  };
}

export function searchProductErrorFn(error: HTTPError): SearchStepAction {
  return {
    type: SEARCH_STEP_SEARCH_ERROR,
    error,
  };
}

export const actions = {
  SEARCH_STEP_SEARCH_REQUEST,
  SEARCH_STEP_SEARCH_SUCCESS,
  SEARCH_STEP_SEARCH_ERROR,
  searchProduct,
  searchProductSuccess,
  searchProductErrorFn,
};

export const initialState: SearchStepState = {
  page: 0,
  pageCanAsk: true,
};

// Reducer
export default function reducer(state: SearchStepState = initialState, action: SearchStepAction): SearchStepState {
  switch (action.type) {
    case SEARCH_STEP_SEARCH_REQUEST:
      if (action.resetPagination) {
        return {
          isFetchingProducts: true,
          page: 0,
          pageCanAsk: true,
        };
      }

      return {
        isFetchingProducts: true,
        products: state.products,
        page: state.page,
        pageCanAsk: state.pageCanAsk,
      };
    case SEARCH_STEP_SEARCH_SUCCESS:
      return {
        products: [...(state.products || []), ...(action.products || [])],
        page: state.page + 1,
        pageCanAsk: !action.isLast,
      };
    case SEARCH_STEP_SEARCH_ERROR:
      return {
        products: state.products,
        page: state.page,
        pageCanAsk: false,
        fetchProductsError: action.error,
      };
    default:
      return state;
  }
}

// Epics

export function searchProductEpic(action$: Observable<SearchStepAction>,
                                  state$: StateObservable<RootState>): Observable<SearchStepAction> {
  return action$.pipe(
    ofType(SEARCH_STEP_SEARCH_REQUEST),
    debounceTime(600),
    switchMap(({ name, queryFilter }) => searchProductApi({
        ...queryFilter,
        query: name,
        page: state$.value.newOrder.searchStep.page,
      }).pipe(
      takeUntil(action$.pipe(ofType(NewOrderActions.NEW_ORDER_RESET_STATE))),
      takeUntil(action$.pipe(ofType(SEARCH_STEP_SEARCH_REQUEST))),
      map((response: { products: SearchProduct[], isLast: boolean }) =>
        searchProductSuccess(response.products, response.isLast)),
      catchError((e: HTTPError) => of(searchProductErrorFn(e)))),
    ));
}



// WEBPACK FOOTER //
// ./src/modules/new-order/SearchStep/duck.js